import { useHistory } from "react-router-dom"

import { usePermissionStateStore } from "@/store/PermissionState"

const usePage = () => {
	const history = useHistory()
	const { checkPermission } = usePermissionStateStore()

	const returnToMainPage = async () => {
		const canAccessManagerPanel = await checkPermission("manager-panel", "access")

		if (canAccessManagerPanel) {
			history.push("/admin")
		} else {
			history.push("/attendance")
		}
	}

	return {
		returnToMainPage
	}
}

export default usePage
